import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONSTANTES } from "../shared/global";
import { Pin } from '../models/Pin';
import { DataPin } from '../models/DataPin';
import { PinGroup } from '../models/PinGroup';

@Injectable({
    providedIn: 'root'
})
export class PinService {

    public url: string;

    constructor(private http: HttpClient) {
        this.url = CONSTANTES.api_url + "/pins";
    }

    /**Obtiene todas los roles*/
    getAllPins() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.get<DataPin>(this.url + "/allPins", { headers: iheaders });
    }

     /**Guarda un pinGroup*/
     savePinGroup(group: PinGroup) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.post<DataPin>(this.url + "/saveGroup", JSON.stringify(group), { headers: iheaders });
    }

    /**Obtiene el pinGroups del usuuario */
    getPinsByUser(nid: string) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.post<DataPin>(this.url + "/getGroupByUser", nid, { headers: iheaders });
    }

     /**Borra un pinGroup*/
     deletePinGroup(group: PinGroup) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.post<DataPin>(this.url + "/deleteGroup", JSON.stringify(group), { headers: iheaders });
    }
}